import React from 'react';

import * as Modules from './blocks/index.js';

/**
 * @type {import('$types/components/partials/modules.d.ts').ModuleDispatcher}
 */

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const ModuleDispatcher = ({ __typename, ...props }) => {
    const ModuleComponent = Modules[__typename];

    if (!ModuleComponent) {
        console.warn(`Could not find module component ${__typename}`);
        return null;
    }

    return (
        <ModuleComponent {...props}/>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ModuleDispatcher;
